import http from '../plugins/axios';

export default {
  async index(client, producer, event) {
    const response = await http.get(`/api/client/${client.id}/producer/${producer.id}/event/${event.id}/voucher`)
    
    return response.data;
  }
}